define.alias("shared/components/shared/credentials/upgrade-button", "media/components/shared/credentials/upgrade-button");